export default __webpack_public_path__ + "static/media/14.285f9172.jpg";